import PageContext from "global_state/context/PageContext"
import { useContext, useEffect, useState } from "react"
import getUserMemberships from "services/user_services/GetUserMembership"
import { MembershipI } from "types/MembershipsI"
import Loader from "./Loader"

import SCSS from 'assets/scss/Memberships.module.scss'
import { ResponseError } from "types/responses/ResponseError"
import Title from "./Title"

import content from 'languages/Memberships.json'
import UserContext from "global_state/context/UserContext"


function Memberships() {
    const {page} = useContext(PageContext)
    const {user} = useContext(UserContext)
    let language = page.settings.language

    const [memberships_response, setMembershipsResponse] = useState<string | MembershipI[]>()

    useEffect(() => {

        if (memberships_response !== undefined)  {
            return
        }
        const getMemberships = async () => {
            setMembershipsResponse(await getUserMemberships(user.client_id))
        };
        
        getMemberships();


    }, [user.client_id, memberships_response])

    useEffect(() => {
        // console.log(memberships_response);
        
    }, [memberships_response])
   

    if (!memberships_response) {
        return <Loader/>
    }

    if (typeof memberships_response === 'string') {
        return <Loader error={ResponseError.general_error}/>
    }

    const renderMemberships = memberships_response.map((membership, index) => {
        // console.log(membership);
        
        return (
            <Membership key={index} membership={membership}/>
        )
    });

    return (
        <div className={SCSS.memberships}>  
            <Title back_arrow={true} title={content[language].title} />
            <div className={SCSS.membershipsWrap}>
                {renderMemberships}
            </div>
        </div>
    )
}

interface MembershipProps {
    membership: MembershipI
}

function Membership(props: MembershipProps) {
    
    const {page} = useContext(PageContext)
    let language = page.settings.language


    const renderDate = (date:Date | null, add_day = 0) => {
        if (!date) {
            return null
        }
        // let year = date.getFullYear()
        let month = date.getUTCMonth() + 1
        let day = (date.getUTCDate() + add_day)
        return (
            <div>{day}.{month}.</div>
        )
    }

    const renderEntries = () => {
        if (!props.membership.entries) {
            return null
        }
        return (
            props.membership.remaining_entries + "/" + props.membership.entries
        )
    }

    return (
        <div className={SCSS.membership}>
            <div className={SCSS.membership_date}> 
                <div className={SCSS.from}>
                    {content[language].valid_from}
                    {renderDate(props.membership.valid_from, 1)}
                </div>
                <div className={SCSS.to}>
                    {content[language].valid_to}
                    {renderDate(props.membership.valid_to)}
                </div>
                
            </div>      
            <div className={SCSS.membership_content}>
                <div>{props.membership.name}</div>
                <div className={SCSS.membershipEntries}>{renderEntries()}</div>           
            </div>      
            
            
        </div>
    )
}

export default Memberships
